/** Formato do filtro de mês: YYYY-MM */
export type MesFiltro = string

export function mesAtualKey(date = new Date()): MesFiltro {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

export function parseMesFiltro(mesKey: MesFiltro) {
  const [y, m] = mesKey.split('-').map(Number)
  const year = y || new Date().getFullYear()
  const monthIndex = (m || 1) - 1
  const inicio = new Date(year, monthIndex, 1)
  const fim = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999)
  const inicioAnterior = new Date(year, monthIndex - 1, 1)
  const fimAnterior = new Date(year, monthIndex, 0, 23, 59, 59, 999)
  return { year, monthIndex, inicio, fim, inicioAnterior, fimAnterior }
}

export function labelMesFiltro(mesKey: MesFiltro, opts?: { marcarAtual?: boolean }) {
  const { inicio } = parseMesFiltro(mesKey)
  const nome = inicio.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
  const capitalizado = nome.charAt(0).toUpperCase() + nome.slice(1)
  if (opts?.marcarAtual && mesKey === mesAtualKey()) {
    return `${capitalizado} (mês atual)`
  }
  return capitalizado
}

/** Últimos N meses (do mais recente ao mais antigo), incluindo o atual. */
export function opcoesMesesFiltro(quantidade = 24): { value: MesFiltro; label: string; isAtual: boolean }[] {
  const agora = new Date()
  const atual = mesAtualKey(agora)
  const opcoes: { value: MesFiltro; label: string; isAtual: boolean }[] = []

  for (let i = 0; i < quantidade; i++) {
    const d = new Date(agora.getFullYear(), agora.getMonth() - i, 1)
    const value = mesAtualKey(d)
    opcoes.push({
      value,
      label: labelMesFiltro(value, { marcarAtual: true }),
      isAtual: value === atual,
    })
  }

  return opcoes
}
